<template>
  <page layoutClass="manage-users">
    <b-row class="mb-3">
      <b-col cols="12" sm="7">
        <h2 class="m-0">Manage Users</h2>
      </b-col>
      <b-col cols="12" sm="5" class="d-flex flex-row justify-content-end align-items-center">
        <!-- <b-button class="mr-3" size="md" variant="outline-primary" v-if="isRecruiterAdmin" @click.prevent="() => selectedUserID = 'ADD'">
          <font-awesome-icon icon="plus"/>
          <span class="d-none d-sm-inline-block">Add</span>
        </b-button> -->
        <!-- <b-button class="mr-3 d-none d-sm-inline-block" size="md" variant="outline-primary" v-if="isRecruiterAdmin" @click.prevent="() => selectedUserID = 'IMPORT'">
          <font-awesome-icon icon="file-import"/>
          <span class="d-none d-sm-inline-block">Import</span>
        </b-button> -->
        <b-button class="mr-3" size="md" variant="outline-primary" v-if="allowInvitations" :to="{ name: 'ManageUserInvites' }">
          <font-awesome-icon icon="plus"/>
          <span class="d-none d-sm-inline-block">Invite</span>
        </b-button>

        <b-button class="mr-3" size="md" variant="outline-primary" @click.prevent="() => showFilters = !showFilters">
          <font-awesome-icon icon="filter"/>
          <span class="d-none d-sm-inline-block">Filter</span>
        </b-button>

        <b-card class="shadow" body-class="d-flex flex-row justify-content-between align-items-center p-1">
          <b-form-select :options="userOrderByEnums" :style="{ width: '200px' }" v-model="filterUsersOrder"/>
        </b-card>
      </b-col>
    </b-row>

    <error-block v-if="allUsersErr" class="mb-3" :err="allUsersErr"/>

    <b-card class="shadow mb-3" v-if="showFilters">
      <boolean-search :fields="searchFields" :value="filterUsersWhere" @input="filterUsersWhereUpdated"/>
    </b-card>

    <b-card class="shadow p-0" no-body>
      <!-- selectable select-mode="range" selectedVariant="success" @row-selected="onItemSelected" -->
      <b-table table-class="m-0" hover striped small responsive show-empty
        :busy="$apollo.queries.userConnections.loading" :fields="fields" :items="items">
          <template #cell(avatar)="{ item }">
            <avatar :user="item" :size="30"/>
          </template>
          <template #cell(fullName)="{ item }">
            <div style="cursor: pointer" @click="openProfile(item)">{{ item.fullName }}</div>
          </template>
          <template #cell(mentorStatus)="{ item }">
            <div>
            <div style="cursor: pointer" @click="$bvModal.show(`update-status-modal-${item.id}`)">{{ item.mentorStatus }}</div>
                <b-modal
                  v-if="item.mentorStatus"
                  :id="`update-status-modal-${item.id}`"
                  size="sm"
                  title="Update Mentor Status"
                  hide-footer
                >
                  <update-mentor-status-form
                    :value="item.mentorStatus"
                    role="admin"
                    @input="updateMentorStatus({ mentorStatus: $event, userID: item.id })"
                  />
                </b-modal>
            </div>
          </template>
          <template #cell(opts)="{ item }">
            <b-btn
              v-if="isRecruiterAdmin && ['INACTIVE', 'ACTIVE', 'REQUESTED'].includes(item.mentorStatus)"
              class="float-right ml-2"
              @click.prevent="openEditMentorship(item)"
              size="sm"
              variant="outline-primary"
            >
              <font-awesome-icon icon="graduation-cap"/>
            </b-btn>
            <b-btn
              v-if="isRecruiterAdmin && item.isTalent"
              class="float-right ml-2"
              @click.prevent="openLineManagerEditProfile(item)"
              size="sm"
              variant="outline-primary"
            >
              <font-awesome-icon icon="user"/>
            </b-btn>
            <b-btn
              v-if="isRecruiterAdmin"
              class="float-right"
              @click.prevent="openEditProfile(item)"
              size="sm"
              variant="outline-primary"
            >
              <font-awesome-icon icon="pencil-alt"/>
            </b-btn>
          </template>
      </b-table>

      <b-card class="mt-3 border-0" body-class="d-flex flex-row p-3 justify-content-center align-items-center" v-if="userConnections && userConnections.total">
        <b-pagination class="m-0" v-model="filterUsersPage" :per-page="userConnections.limit" :total-rows="userConnections.total"/>
      </b-card>

    </b-card>

    <!-- <b-modal v-if="selectedUserID === 'ADD'" :visible="true"
      size="lg" title="Add User" no-close-on-backdrop hide-footer @hide="closeSelectedUserModal">
        <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
        <create-profile-form as-admin @input="createNewUser"/>
    </b-modal> -->
    <!-- <b-modal v-else-if="selectedUserID === 'IMPORT'" :visible="true"
      size="lg" title="Import Users" no-close-on-backdrop hide-footer @hide="closeSelectedUserModal">
        <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
        <edit-profile-form as-admin @input="importUsers">
          <template v-slot:buttonActions="{ changed }">
            <b-form-group>
              <b-button size="md" type="submit" :disabled="!changed" variant="primary">Import</b-button>
            </b-form-group>
          </template>
        </edit-profile-form>
    </b-modal> -->

    <!-- Show Profile Modal -->
    <b-modal
      id="profile-show-modal"
      title="Profile"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <profile-show
        :company="selectedUser.company"
        :user="selectedUser.value"
        layout="modal"
      />
    </b-modal>

    <!-- Edit Profile Modal -->
    <b-modal id="profile-edit-modal"
      size="lg" title="Edit User" no-close-on-backdrop hide-footer @hide="closeSelectedUserModal">
        <template v-if="selectedUser && selectedUser.value">
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <edit-profile-form as-admin in-modal v-bind="selectedUser" @input="updateSelectedUser">
            <template v-slot:buttonActions="{ changed }">
              <b-form-group>
                <b-button size="md" type="submit" :disabled="!changed" variant="primary">Save</b-button>
                <b-button v-if="selectedUser.value.status === 'ACTIVE'" size="md" variant="danger" @click="disableSelectedUser">Disable</b-button>
                <b-button v-if="selectedUser.value.status === 'INACTIVE'" size="md" variant="info" @click="enableSelectedUser">Enable</b-button>
                <b-button v-if="selectedUser.value.status === 'INACTIVE'" size="md" variant="danger" @click="deleteSelectedUser">Delete</b-button>
                <b-button v-if="selectedUser.value.status === 'DELETED'" size="md" variant="info" @click="enableSelectedUser">Enable</b-button>
              </b-form-group>
            </template>
          </edit-profile-form>
        </template>
        <template v-else>
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <p v-else>Loading...</p>
        </template>
    </b-modal>

    <!-- Line Manager Edit Profile Modal -->
    <b-modal id="line-manager-profile-edit-modal"
      size="lg" title="Edit User" no-close-on-backdrop hide-footer @hide="closeSelectedUserModal">
        <template v-if="selectedUser && selectedUser.value">
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <b-tabs content-class="mt-3">
            <b-tab title="Profile Details" active>
              <profile-show
                :company="selectedUser.company"
                :user="selectedUser.value"
                layout="modal"
              />
            </b-tab>
            <b-tab title="Line Manager Notes">
              <b-row>
                <b-col>
                  <b-form @submit.prevent="() => {}">
                    <b-form-group label="Readiness for the Next Role" label-for="readiness-input">
                      <b-form-textarea
                        id="readiness-input"
                        placeholder="Describe their readiness for the next role"
                        rows="3"
                        max-rows="6">
                      </b-form-textarea>
                    </b-form-group>

                    <b-form-group label="Hard to Fill/Critical Role" label-for="critical-role-input">
                      <b-form-textarea
                        id="critical-role-input"
                        placeholder="Is it a hard to fill role? Describe the role and why it's critical"
                        rows="3"
                        max-rows="6">
                      </b-form-textarea>
                    </b-form-group>

                    <b-button variant="primary">Save</b-button>
                  </b-form>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </template>
        <template v-else>
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <p v-else>Loading...</p>
        </template>
    </b-modal>

    <!-- Edit Mentorship Modal -->
    <b-modal id="mentorship-edit-modal"
      size="lg" title="Edit Mentorship" no-close-on-backdrop hide-footer @hide="closeSelectedUserModal">
        <template
          v-if="selectedUser && selectedUser.value && ['INACTIVE', 'ACTIVE', 'REQUESTED'].includes(selectedUser.value.mentorStatus)"
        >
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <profile-editor
            v-else
            :fields="mentorshipFormContent.fields"
            :value="mentorshipFormContent.values"
            @input="updateMentorship($event)"
            @cancel="$bvModal.hide('mentorship-edit-modal')"
          />
        </template>
        <template v-else>
          <error-block v-if="selectedUserErr" class="mb-3" :err="selectedUserErr"/>
          <p v-else>Loading...</p>
        </template>
    </b-modal>

  </page>
</template>

<script>
import Page from '@/components/Page';
import enumsMixin from '@/mixins/enums';
import formatDate from 'date-fns/format';
import ErrorBlock from '@/components/misc/ErrorBlock';
import UsersListQuery from '@/graphql/queries/UsersList.gql';
import UserEditQuery from '@/graphql/queries/UserEdit.gql';
import UserEditMutation from '@/graphql/mutations/UserEdit.gql';
import UserCreateMutation from '@/graphql/mutations/UserCreate.gql';
import BooleanSearch from '@/components/misc/BooleanSearch';
import EditProfileForm from '@/components/users/EditProfileForm';
import ProfileShow from '@/components/profile/ProfileShow';
import UpdateMentorStatusForm from '@/components/mentors/UpdateMentorStatusForm';
import UpdateMentorStatusMutation from '@/graphql/mutations/UpdateMentorStatus.gql';
import ProfileEditor from '@/components/profile/ProfileEditor';
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';
import Avatar from '@/components/users/Avatar';

const WriteUserQuestionsMutation = gql`
  mutation WriteSelectedUserCustomFields(
    $userID: ID!,
    $mentorStatus: MentorStatus!
    $update: [ UpdateUserCustomFieldInput! ]!
  ) {
    updateUser(
      where: { id: $userID },
      update: {
        customFields:  $update,
        mentorStatus: $mentorStatus,
      }
    ) {
      id
    }
  }
`;

export default {
  components: {
    Page,
    ErrorBlock,
    BooleanSearch,
    EditProfileForm,
    ProfileShow,
    UpdateMentorStatusForm,
    ProfileEditor,
    Avatar,
  },
  mixins: [
    enumsMixin,
  ],
  data: () => ({
    allUsersErr: null,
    selectedUserID: null,
    selectedUserErr: null,
    filterUsersPage: 1,
    filterUsersLimit: 100,
    filterUsersWhere: {
      status: 'ACTIVE',
    },
    filterUsersOrder: 'CREATED_ASC',
    showFilters: false,
    selectedUser: {
      company: null,
      value: null,
    },
  }),
  apollo: {
    userConnections: {
      query: UsersListQuery,
      variables() {
        const { filterUsersPage, filterUsersLimit, filterUsersWhere, filterUsersOrder } = this;
        return { filterUsersPage, filterUsersLimit, filterUsersWhere, filterUsersOrder };
      },
      update: ({ company: { userConnections } }) => userConnections,
      error(err) {
        this.allUsersErr = err;
      },
      fetchPolicy: 'network-only',
      deep: true,
    },
    selectedUser: {
      query: UserEditQuery,
      variables() {
        const { selectedUserID: userID } = this;
        return { userID };
      },
      update: ({ company: { value, ...company } }) => ({ company, value }),
      result() {
        console.log(this.selectedUser);
      },
      error(err) {
        this.selectedUserErr = err;
      },
      skip() {
        return !this.selectedUserID || [ 'ADD', 'IMPORT' ].includes(this.selectedUserID);
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiterAdmin', 'allowInvitations' ]),
    fields() {
      return [
        {
          key: 'avatar',
          label: '',
          headerTitle: 'Avatar',
          thStyle: { width: '50px' },
        },
        {
          key: 'fullName',
          label: 'Name',
          thStyle: { width: '150px' },
        },
        {
          key: 'role',
          label: 'Role',
          formatter: value => this.userRoleEnums[value] || value,
          thStyle: { width: '100px' },
        },

        {
          key: 'mentorStatus',
          label: 'Mentor',
          formatter: value => value || '-',
          thStyle: { width: '100px' },
        },
        {
          key: 'emailAddress',
          label: 'Email Address',
          thStyle: { width: '300px' },
        },
        // {
        //   key: 'company',
        //   label: 'Company',
        //   thStyle: { width: '200px' },
        // },
        {
          key: 'title',
          label: 'Title',
          thStyle: { width: '200px' },
        },
        {
          key: 'campaigns',
          label: 'Live Campaign',
          formatter: value => Array.isArray(value) && value.length && value[0].title
            ? (value[0].title.length > 12 ? `${value[0].title.substring(0, 22)}...` : value[0].title)
            : ' - ',
          thStyle: { width: '200px' },
        },
        {
          key: 'created',
          label: 'Created',
          formatter: value => formatDate(value, 'YYYY-MM-DD HH:mm'),
          thStyle: { width: '200px' },
        },
        // {
        //   key: 'updated',
        //   label: 'Updated',
        //   formatter: value => formatDate(value, 'YYYY-MM-DD HH:mm'),
        //   thStyle: { width: '200px' },
        // },
        {
          key: 'status',
          label: 'Status',
          formatter: value => this.userStatusEnums[value] || value,
          thStyle: { width: '50px' },
        },
        {
          key: 'opts',
          label: '',
          headerTitle: 'Options',
          thStyle: { width: '120px' },
        },
      ];
    },
    items() {
      const { edges } = this.userConnections || {};
      if (Array.isArray(edges) && edges.length) {
        return edges.reduce((list, row) => {
          if (row && row.entry && row.entry.id && row.entry.role !== 'SUPER_ADMIN') {
            list.push(row.entry);
          }
          return list;
        }, []);
      } else {
        return [];
      }
    },
    searchFields() {
      const { origin } = this.$root;

      return {
        name: {
          label: 'Name',
          placeholder: 'First or Last Name...',
          type: 'STRING',
        },
        emailAddress: {
          label: 'Email Address',
          placeholder: '...@example.com',
          type: 'STRING',
        },
        role: {
          label: 'Role',
          type: 'ENUM',
          options: this.userRoleEnums,
          empty: 'All',
        },
        company: {
          label: 'Company',
          placeholder: 'Example Corp',
          type: 'STRING',
        },
        title: {
          label: 'Title',
          placeholder: 'Example Associate',
          type: 'STRING',
        },
        mentorStatus: {
          label: 'Mentor Status',
          type: 'STRING',
        },
        share: {
          label: 'Share URL',
          placeholder: `${origin}/r/...`,
          type: 'STRING',
          set: value => {
            if (value.indexOf('http') === 0) {
              const [ , ...paths ] = value.substr('https://'.length).split('/');
              const { route } = this.$router.resolve([].concat(paths).join('/'), '/');
              if (route && route.params && route.params.shareCode) {
                console.log(route);
                value = route.params.shareCode;
              }
            } else if (value.indexOf('/r/') === 0) {
              const { route } = this.$router.resolve(value, '/');
              if (route && route.params && route.params.shareCode) {
                value = route.params.shareCode;
              }
            }

            return value;
          },
        },
        status: {
          label: 'Status',
          type: 'ENUM',
          options: this.userStatusEnums,
        },
        logEvents: {
          label: 'Activity',
          type: 'ENUM',
          options: [
            { text: 'All', value: null },
            { text: 'Synced Connections', value: 'CONTACT_NETWORK_SYNCED' },
            { text: 'Have Not Synced Connections', value: 'NOT_CONTACT_NETWORK_SYNCED' },
            { text: 'Shared Jobs', value: 'JOB_SHARED' },
            { text: 'Have Not Shared Jobs', value: 'NOT_JOB_SHARED' },
            { text: 'Referred Contacts', value: 'REFERRAL_SUGGESTED' },
            { text: 'Have Not Referred Contacts', value: 'NOT_REFERRAL_SUGGESTED' },
          ],
        },
      };
    },
    page() {
      const { page } = this.userConnections;
      return page || 1;
    },
    limit() {
      const { limit } = this.userConnections;
      return limit || 10;
    },
    customFields() {
      const { selectedUser: { value: user, company: { customFields } = {} } = {} } = this;
      const userDepartments = Array.isArray(user.departments) ? user.departments.map(({ id }) => id) : [];
      const fields = (Array.isArray(customFields) ? customFields : []).map(({ options, departments, ...field }) => ({
        ...field,
        departments: departments ? departments.map(({ id }) => id) : null,
      })).filter(({ departments }) => departments ? departments.filter(el => userDepartments.includes(el)).length : true);
      return fields;
    },
    selectedUserCustomFieldValues() {
      const { selectedUser: { value: user } = {}, parseIfPossible } = this;
      if (user && Array.isArray(user.customFields) && user.customFields.length) {
        const values = user.customFields.reduce((values, { key, value }) => Object.assign(values, { [key]: parseIfPossible(value) }), {});
        console.log('SELECTED USER CUSTOM FIELD VALUES: ', values);
        return values;
      }
      return null;
    },
    mentorshipFormContent() {
      const { selectedUserCustomFieldValues: values, customFields } = this;
      const fields = customFields.filter(el => el.group === 'mentorship');
      return {
        name: 'mentorship',
        fields,
        values,
      };
    },
  },
  methods: {
    openEditProfile(item) {
      this.selectedUserID = item.id;
      this.$bvModal.show('profile-edit-modal');
    },
    openLineManagerEditProfile(item) {
      this.selectedUserID = item.id;
      this.$bvModal.show('line-manager-profile-edit-modal');
    },
    openProfile(item) {
      this.selectedUserID = item.id;
      this.$bvModal.show('profile-show-modal');
    },
    openEditMentorship(item) {
      this.selectedUserID = item.id;
      this.$bvModal.show('mentorship-edit-modal');
    },
    onItemSelected(items) {
      console.log('onItemSelected', items.map(({ id }) => id));
    },
    async updateMentorStatus({ mentorStatus, userID }) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: UpdateMentorStatusMutation,
          variables: {
            userID,
            mentorStatus,
          },
          // update(store, { data: { updateUser } }) {
          //   const data = store.readQuery({ query: UserProfileQuery });
          //   data.user.mentorStatus = updateUser.mentorStatus;
          //   store.writeQuery({ query: UserProfileQuery, data });
          // },
        });
        console.log('SUCCESS: ', data);

        // log mentor status changes
        if (mentorStatus === 'ACTIVE') {
          Promise.resolve(this.$root.captureLog({
            eventName: 'IM_MENTOR_ACCEPTED',
            user: { id: userID },
          }));
        } else if (mentorStatus === 'REJECTED') {
          Promise.resolve(this.$root.captureLog({
            eventName: 'IM_MENTOR_REJECTED',
            user: { id: userID },
          }));
        } else if (mentorStatus === 'INACTIVE') {
          Promise.resolve(this.$root.captureLog({
            eventName: 'IM_MENTOR_STATUS_UPDATED',
            user: { id: userID },
          }));
        }
      } catch (error) {
        console.error(error);
      }
      this.$bvModal.hide(`update-status-modal-${userID}`);
    },
    filterUsersWhereUpdated(where) {
      this.filterUsersWhere = where;
      this.filterUsersPage = 1;
    },
    async closeSelectedUserModal() {
      try {
        await this.$apollo.queries.userConnections.refetch();
      } catch (err) {
        console.error(err);
      } finally {
        this.selectedUserErr = null;
        this.selectedUserID = null;
      }
    },
    async createNewUser(create) {
      try {
        Object.assign(create, {
          role: 'EMPLOYEE',
          status: 'ACTIVE',
        });

        const { data } = await this.$apollo.mutate({
          mutation: UserCreateMutation,
          variables: { create },
        });

        if (data && data.createNewUser && data.createNewUser.id) {
          const { fullName } = data.createNewUser;
          this.$notification({
            title: 'User created',
            message: `${fullName}'s account has been created`,
            variant: 'success',
          });
        } else {
          throw new Error('Failed to create new user');
        }

        await this.closeSelectedUserModal();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async updateSelectedUser({ avatar, ...update }) {
      const { selectedUserID: userID } = this;
      if (!userID) {
        return this.$notifyErr(new Error('Missing selectedUserID'));
      }

      try {
        await this.$apollo.mutate({
          mutation: UserEditMutation,
          variables: { userID, update },
          // @TODO If the result doesn't match the current query, remove from the results set?
        });

        const { fullName } = this.selectedUser.value;
        this.$notification({
          title: 'User saved',
          message: `${fullName}'s account has been updated`,
          variant: 'success',
        });

        await this.closeSelectedUserModal();
      } catch (err) {
        this.selectedUserErr = err;
      }
    },
    async disableSelectedUser() {
      const { selectedUserID: userID } = this;
      if (!userID) {
        return this.$notifyErr(new Error('Missing selectedUserID'));
      }

      const { status } = this.selectedUser;
      if (status === 'INACTIVE') {
        const { fullName } = this.selectedUser.value;
        return this.$notification({
          title: 'User is already enabled',
          message: `${fullName}'s account is already disabled`,
          variant: 'warning',
        });
      }

      try {
        await this.$apollo.mutate({
          mutation: UserEditMutation,
          variables: { userID, update: { status: 'INACTIVE' } },
          // @TODO If the result doesn't match the current query, remove from the results set?
        });

        const { fullName } = this.selectedUser.value;
        this.$notification({
          title: 'User disabled',
          message: `${fullName}'s account has been disabled`,
          variant: 'success',
        });
      } catch (err) {
        this.selectedUserErr = err;
      }
    },
    async enableSelectedUser() {
      const { selectedUserID: userID } = this;
      if (!userID) {
        return this.$notifyErr(new Error('Missing selectedUserID'));
      }

      const { status } = this.selectedUser;
      if (status === 'ACTIVE') {
        const { fullName } = this.selectedUser.value;
        return this.$notification({
          title: 'User is already enabled',
          message: `${fullName}'s account is already enabled`,
          variant: 'warning',
        });
      }

      try {
        await this.$apollo.mutate({
          mutation: UserEditMutation,
          variables: { userID, update: { status: 'ACTIVE' } },
          // @TODO If the result doesn't match the current query, remove from the results set?
        });

        const { fullName } = this.selectedUser.value;
        this.$notification({
          title: 'User disabled',
          message: `${fullName}'s account has been enabled`,
          variant: 'success',
        });
      } catch (err) {
        this.selectedUserErr = err;
      }
    },
    async deleteSelectedUser() {
      const { selectedUserID: userID } = this;
      if (!userID) {
        return this.$notifyErr(new Error('Missing selectedUserID'));
      }

      const { status } = this.selectedUser;
      if (status === 'DELETED') {
        const { fullName } = this.selectedUser.value;
        return this.$notification({
          title: 'User is already deleted',
          message: `${fullName}'s account is already deleted`,
          variant: 'warning',
        });
      }

      try {
        await this.$apollo.mutate({
          mutation: UserEditMutation,
          variables: { userID, update: { status: 'DELETED' } },
          // @TODO If the result doesn't match the current query, remove from the results set?
        });

        const { fullName } = this.selectedUser.value;
        this.$notification({
          title: 'User deleted',
          message: `${fullName}'s account has been deleted`,
          variant: 'success',
        });
      } catch (err) {
        this.selectedUserErr = err;
      }
    },
    parseIfPossible(value) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        // not a json
      }
      return value;
    },
    async updateMentorship(inputValues) {
      try {
        if (Object.keys(inputValues).length) {
          const { selectedUserID: userID } = this;
          const { selectedUser: { value: { mentorStatus } } = {} } = this;
          console.log({ userID, inputValues, mentorStatus });
          await this.$apollo.mutate({
            mutation: WriteUserQuestionsMutation,
            variables: {
              mentorStatus,
              userID,
              update: Object.keys(inputValues).map(key => ({
                key,
                value: typeof inputValues[key] === 'string' ? inputValues[key] : (inputValues[key] ? JSON.stringify(inputValues[key]) : null),
              })).filter(({ value }) => value),
            },
          });
        }

        this.$bvModal.hide('mentorship-edit-modal');
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Recruiter/ListUsers.vue